// Place names and coordinates for the gallery.
//
// PLACES is keyed by the correct "City|Country"; `name` is the label shown and
// lat/lng place the Atlas dot. ALIASES maps misspelled or alternative city
// names found on image docs to the correct one — normalizePlace() applies it
// as data loads, so captions, the lightbox and the Atlas all agree.
//
// Photos from a city that isn't listed here still show everywhere (and in the
// Atlas index), just without a dot — add a line (lat, lng in decimal degrees).

const P = (name, lat, lng) => ({ name, lat, lng });

const PLACES = {
  'Kyoto|Japan': P('Kyoto', 35.0116, 135.7681),
  'Paris|France': P('Paris', 48.8566, 2.3522),
  'Angkor Wat|Cambodia': P('Angkor Wat', 13.4125, 103.867),
  'Seoul|South Korea': P('Seoul', 37.5665, 126.978),
  'Buenos Aires|Argentina': P('Buenos Aires', -34.6037, -58.3816),
  'Petra|Jordan': P('Petra', 30.3285, 35.4444),
  'Hanoi|Vietnam': P('Hanoi', 21.0278, 105.8342),
  'Athens|Greece': P('Athens', 37.9838, 23.7275),
  'Copenhagen|Denmark': P('Copenhagen', 55.6761, 12.5683),
  'Atacama|Chile': P('Atacama', -22.9087, -68.1997),
  'Wadi Rum|Jordan': P('Wadi Rum', 29.5729, 35.4209),
  'Alexandria|Egypt': P('Alexandria', 31.2001, 29.9187),
  'Lisbon|Portugal': P('Lisbon', 38.7223, -9.1393),
  'Hangzhou|China': P('Hangzhou', 30.2741, 120.1551),
  'Vienna|Austria': P('Vienna', 48.2082, 16.3738),
  'Sacred Valley|Peru': P('Sacred Valley', -13.3047, -72.116),
  'Kuala Lumpur|Malaysia': P('Kuala Lumpur', 3.139, 101.6869),
  'Chengdu|China': P('Chengdu', 30.5728, 104.0668),
  'Ouzoud|Morocco': P('Ouzoud', 32.0153, -6.7189),
  'Strasbourg|France': P('Strasbourg', 48.5734, 7.7521),
  'Chiang Mai|Thailand': P('Chiang Mai', 18.7883, 98.9853),
  'Sevilla|Spain': P('Sevilla', 37.3891, -5.9845),
  'Flensburg|Germany': P('Flensburg', 54.7937, 9.447),
  'Rapa Nui|Chile': P('Rapa Nui', -27.1127, -109.3497),
  'Madrid|Spain': P('Madrid', 40.4168, -3.7038),
  'Karnak|Egypt': P('Karnak', 25.7188, 32.6573),
  'Amman|Jordan': P('Amman', 31.9454, 35.9284),
  'Bangkok|Thailand': P('Bangkok', 13.7563, 100.5018),
  'Damnoen Saduak|Thailand': P('Damnoen Saduak', 13.5196, 99.9559),
  'Koh Samui|Thailand': P('Koh Samui', 9.512, 100.0136),
  'Los Angeles|United States': P('Los Angeles', 34.0522, -118.2437),
  'Granada|Spain': P('Granada', 37.1773, -3.5986),
  'Takayama|Japan': P('Takayama', 36.1461, 137.2522),
  'Osaka|Japan': P('Osaka', 34.6937, 135.5023),
  'Brussels|Belgium': P('Brussels', 50.8503, 4.3517),
  'Chefchaouen|Morocco': P('Chefchaouen', 35.1688, -5.2636),
  'Lima|Peru': P('Lima', -12.0464, -77.0428),
  'Mexico City|Mexico': P('Mexico City', 19.4326, -99.1332),
  'Yangshuo|China': P('Yangshuo', 24.7781, 110.4966),
  'Zhangjiajie|China': P('Zhangjiajie', 29.117, 110.4792),
  'Jerash|Jordan': P('Jerash', 32.2747, 35.8961),
  'Ayutthaya|Thailand': P('Ayutthaya', 14.3532, 100.5689),
  'Marrakech|Morocco': P('Marrakech', 31.6295, -7.9811),
  'Doi Inthanon|Thailand': P('Doi Inthanon', 18.5883, 98.4867),
  'Ho Chi Minh City|Vietnam': P('Ho Chi Minh City', 10.8231, 106.6297),
  'Hoi An|Vietnam': P('Hoi An', 15.8801, 108.338),
  'Ha Long Bay|Vietnam': P('Ha Long Bay', 20.9101, 107.1839),
  'Cairo|Egypt': P('Cairo', 30.0444, 31.2357),
  'Philae|Egypt': P('Philae', 24.0254, 32.8844),
  'Bora Bora|French Polynesia': P('Bora Bora', -16.5004, -151.7415),
  'Antibes|France': P('Antibes', 43.5808, 7.1251),
  'Machu Picchu|Peru': P('Machu Picchu', -13.1631, -72.545),
  'Little Petra|Jordan': P('Little Petra', 30.3728, 35.4508),
  'Casablanca|Morocco': P('Casablanca', 33.5731, -7.5898),
  'Agafay|Morocco': P('Agafay', 31.45, -8.2),
  'Siem Reap|Cambodia': P('Siem Reap', 13.3633, 103.8564),
  'My Tho|Vietnam': P('My Tho', 10.36, 106.36),
  'Fes|Morocco': P('Fes', 34.0181, -5.0078),
  'Kurama|Japan': P('Kurama', 35.117, 135.771),
  'Nara|Japan': P('Nara', 34.6851, 135.8048),
  'Imaicho|Japan': P('Imaicho', 34.5019, 135.7917),
  'Batu Caves|Malaysia': P('Batu Caves', 3.2379, 101.684),
  'Beijing|China': P('Beijing', 39.9042, 116.4074),
  'Sahara|Morocco': P('Sahara', 31.099, -4.0128),
  'Rissani|Morocco': P('Rissani', 31.278, -4.264),
  'Pingyao|China': P('Pingyao', 37.201, 112.177),
  'Essaouira|Morocco': P('Essaouira', 31.5085, -9.7595),
  'Estepona|Spain': P('Estepona', 36.4256, -5.1459),
  'Medellín|Colombia': P('Medellín', 6.2442, -75.5812),
  'Cascais|Portugal': P('Cascais', 38.6979, -9.4215),
  'Cabo da Roca|Portugal': P('Cabo da Roca', 38.7804, -9.4989),
  'Nanjing|China': P('Nanjing', 32.0603, 118.7969),
  'Kerak|Jordan': P('Kerak', 31.1853, 35.7048),
  'Ouarzazate|Morocco': P('Ouarzazate', 30.9189, -6.8934),
  'Hamburg|Germany': P('Hamburg', 53.5511, 9.9937),
  'Kbal Spean|Cambodia': P('Kbal Spean', 13.68, 104.02),
  'Córdoba|Spain': P('Córdoba', 37.8882, -4.7794),
  'Saint-Paul-de-Vence|France': P('Saint-Paul-de-Vence', 43.6966, 7.1222),
  'Nagoya|Japan': P('Nagoya', 35.1815, 136.9066),
  'Kobe|Japan': P('Kobe', 34.6901, 135.1955),
  'Meknes|Morocco': P('Meknes', 33.8935, -5.5473),
  'Schleswig|Germany': P('Schleswig', 54.515, 9.569),
  "Tizi n'Tichka|Morocco": P("Tizi n'Tichka", 31.2867, -7.3836),
  'Badaling|China': P('Badaling', 40.354, 116.02),
  'Puerto Vallarta|Mexico': P('Puerto Vallarta', 20.6534, -105.2253),
  'Ventimiglia|Italy': P('Ventimiglia', 43.7909, 7.6083),
  'Giza|Egypt': P('Giza', 29.9792, 31.1342),
  'Saqqara|Egypt': P('Saqqara', 29.8711, 31.2165),
  'Aswan|Egypt': P('Aswan', 24.0889, 32.8998),
  'Abu Simbel|Egypt': P('Abu Simbel', 22.3372, 31.6258),
  'Geneva|Switzerland': P('Geneva', 46.2044, 6.1432),
};

// "City|Country" as stored → correct city name.
export const ALIASES = {
  'Grenada|Spain': 'Granada',
  'Cordoba|Spain': 'Córdoba',
  'Cape Roca|Portugal': 'Cabo da Roca',
  'Mount Kurama|Japan': 'Kurama',
  'Emaicho|Japan': 'Imaicho',
  'Agafi|Morocco': 'Agafay',
  'Risani|Morocco': 'Rissani',
  'Chaouen|Morocco': 'Chefchaouen',
  'Tizin Tichka|Morocco': "Tizi n'Tichka",
  'Sakkara|Egypt': 'Saqqara',
  'Saint Paul De Vence|France': 'Saint-Paul-de-Vence',
  'Ho Chi Minh|Vietnam': 'Ho Chi Minh City',
  'Medellin|Colombia': 'Medellín',
};

export const placeKey = (img) => `${(img.city || '').trim()}|${(img.country || '').trim()}`;

// Returns the image with its city spelled correctly (same object if unchanged).
export const normalizePlace = (img) => {
  const fixed = ALIASES[placeKey(img)];
  return fixed ? { ...img, city: fixed } : img;
};

export default PLACES;
